import { useMutation } from '@tanstack/react-query';
import Resources from '../../../helpers/resources';
import { getValueFromUrl } from '../../../helpers/utils';

export const useComplete = () => {
  const complete = async () => {
    const res = await Resources.forceComplete
      .post()
      .withBody({
        assignmentId: getValueFromUrl('assignmentId'),
        locale: getValueFromUrl('locale'),
        accuracy: 50
      })
      .send();

    return res;
  };

  return { ...useMutation({
    mutationFn: complete
  }) };
};
